import { computeIsDarkThemeFromThemeMode } from '../utils/computeIsDarkThemeFromThemeMode';
import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';
import type { ThemeMode } from '../schema/ThemeMode';

export const setIsDarkThemeFromThemeMode = mutatorAction(
    'setIsDarkThemeFromThemeMode',
    (themeMode: ThemeMode) => {
        store.isDarkTheme = computeIsDarkThemeFromThemeMode(themeMode);
    }
);
